export function DeleteLocalStorage(key: string) {
  try {
    window.localStorage.removeItem(key)
  } catch (e) {
    console.warn(`Could not delete Local Storage key: "${key}"`)
    console.warn(e)
  }
}

export function SetLocalStorage<T>(key: string, value: T) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.warn(`Could not set Local Storage key: "${key}"`)
    console.warn(e)
  }
  return value
}

export function GetLocalStorage<T>(key: string, defaultValue: T): T {
  try {
    const value = window.localStorage.getItem(key)
    return value !== null ? JSON.parse(value) : defaultValue
  } catch (e) {
    console.warn(`Could not get Local Storage key: "${key}"`)
    console.warn(e)
  }
  return defaultValue
}
